import clsx from "clsx";
import Button from "components/common_components/Button";
import Card from "components/common_components/Card";
import Icon from "components/common_components/Icon";
import React, { useEffect, useState } from "react";
import { hasElements } from "utils/arrays";
import PropTypes from "prop-types";
import { TextField } from "@material-ui/core";

const RequestTypes = ({ requestTypes, visible, onClick, onBackClick, error }) => {
    const [filter, setFilter] = useState("");
    const [filteredRequestTypes, setFilteredRequestTypes] = useState(requestTypes);

    const onFilterChange = (e) => {
        setFilter(e.target.value);
    };

    useEffect(() => {
        if (filter && hasElements(requestTypes)) {
            setFilteredRequestTypes(requestTypes.filter((rt) => JSON.stringify(rt).toLowerCase().includes(filter.toLowerCase())));
        } else {
            setFilteredRequestTypes(requestTypes);
        }

        return () => {
            setFilteredRequestTypes(requestTypes);
        };
    }, [filter, requestTypes]);

    return (
        <div
            className={clsx("layout request-types-container", {
                visible: visible,
                invisible: !visible,
            })}
        >
            {visible && (
                <>
                    <Button secondary link onClick={onBackClick}>
                        <Icon name="arrow" color="secondary" size="xs" style={{ transform: "rotate(90deg)" }} />
                        <span>Back</span>
                    </Button>
                    <hr />
                    <h3>Type</h3>
                    <small>
                        <i>Select a request type</i>
                    </small>
                    <TextField type="text" placeholder="Search..." value={filter} onChange={onFilterChange} />
                    <div className="request-types">
                        {filteredRequestTypes.map((rt) => (
                            <Card key={rt.id} onClick={() => onClick(rt)}>
                                <span>{rt.type}</span>
                                <Icon name="arrow" color="secondary" size="xs" style={{ transform: "rotate(180deg)" }} />
                            </Card>
                        ))}
                    </div>
                    {error && <div className="wizard-error">{error}</div>}
                </>
            )}
        </div>
    );
};

RequestTypes.propTypes = {
    requestTypes: PropTypes.array,
    visible: PropTypes.bool,
    onClick: PropTypes.func,
    onBackClick: PropTypes.func,
    error: PropTypes.string,
};

RequestTypes.defaultProps = {
    requestTypes: [],
    visible: true,
    onClick: () => {},
    onBackClick: () => {},
    error: undefined,
};

export default RequestTypes;
